export const baseTripsPath = ['gmi', 'gma', 'trips'];

export const gmaUpcomingTripsPath = [...baseTripsPath, 'upcoming', 'upcoming_reservations'];
export const gmaCurrentTripsPath = [...baseTripsPath, 'current', 'trip_summaries'];
export const gmaPastTripsPath = [...baseTripsPath, 'past', 'trip_summaries'];
export const gmaPastTripReceiptsPath = [...baseTripsPath, 'invoice'];
